'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _PropertyBag2 = require('../Core/PropertyBag');

var _PropertyBag3 = _interopRequireDefault(_PropertyBag2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Representation of an OauthToken
 * @class
 */
var OauthToken = function (_PropertyBag) {
  (0, _inherits3.default)(OauthToken, _PropertyBag);
  (0, _createClass3.default)(OauthToken, null, [{
    key: 'fromJS',

    /**
     * @static
     * @method
     *
     * @param {{}} js
     * @return {OauthToken}
     */
    value: function fromJS(js) {
      var oauthVersion = js.oauthVersion,
          otherProps = (0, _objectWithoutProperties3.default)(js, ['oauthVersion']);

      return new OauthToken((0, _extends3.default)({ oauthVersion: oauthVersion }, otherProps));
    }

    /**
     * @static
     * @method
     *
     * @param response
     * @return {OauthToken}
     */

  }, {
    key: 'fromOauthProxyResponse',
    value: function fromOauthProxyResponse(response) {
      var oauthVersion = response.oauthVersion;
      var token = response.body.token;


      var props = (0, _extends3.default)({ oauthVersion: oauthVersion }, token);
      return new OauthToken(props);
    }

    /**
     * @param {String} oauthVersion
     * @param {...*} otherProps
     */

  }]);

  function OauthToken(_ref) {
    var oauthVersion = _ref.oauthVersion,
        otherProps = (0, _objectWithoutProperties3.default)(_ref, ['oauthVersion']);
    (0, _classCallCheck3.default)(this, OauthToken);
    return (0, _possibleConstructorReturn3.default)(this, (OauthToken.__proto__ || (0, _getPrototypeOf2.default)(OauthToken)).call(this, (0, _extends3.default)({ oauthVersion: oauthVersion }, otherProps)));
  }

  /**
   * The oauth version for which this token was issued
   *
   * @readonly
   * @type {string}
   */


  (0, _createClass3.default)(OauthToken, [{
    key: 'oauthVersion',
    get: function get() {
      return this.props.oauthVersion;
    }
  }]);
  return OauthToken;
}(_PropertyBag3.default);

exports.default = OauthToken;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Security/OauthToken.js
// module id = 161
// module chunks = 0